export const planCarriersDisplayNames = {
  att: 'AT&T (Syntegra)',
  asp: 'AT&T (ASP)',
  pwg: 'T-Mobile (PWG)',
  telispire: 'Telispire',
  tsp: 'Verizon (TSP)',
  vzwt: 'Internet (VZ)',
};
